
<template>
  <div class="page-form page-base">
    <h3 class="title">2023年合同计划调整申请表</h3>
    <div class="form-container">
      <errors-list :errors="errorList" />
      <div class="tools">
        <form-button v-if="isSave" name="保存" @click="saveData" />
        <template v-else>
          <form-button name="下载" style="margin-right: 10px" @click="downloadPdf" />
          <el-upload
            ref="upload"
            action=""
            :on-change="uploadFile"
            :show-file-list="false"
            :auto-upload="false"
          >
            <form-button slot="trigger" name="上传" />
          </el-upload>
        </template>
      </div>
    </div>
    <div class="table-container">
      <TableCommon title="申请表" :custome-config="() => vxeShowCustom('gridOptionArea')">
        <vxe-grid
          ref="gridOptionArea"
          class="table-block"
          border
          :highlight-hover-row="true"
          resizable
          :show-overflow="true"
          height="240"
          max-height="500"
          align="center"
          size="mini"
          :checkbox-config="{ highlight: true }"
          :radio-config="{ highlight: true }"
          :empty-render="{ name: 'NotData' }"
          :toolbar-config="{ custom: true, size: 'mini' }"
          :row-config="{ isCurrent: true }"
          :edit-config="{ trigger: 'manual', mode: 'row' }"
          :columns="gridOptions.columns"
          :data="gridOptions.data"
        >
          <template #sal_center="{row}">
            <el-select v-model="row.sal_center" size="mini" @change="queryPlan">
              <el-option v-for="item in salCenters" :key="item.zzfld00001h" :value="item.zzfld00001h" :label="item.mc_short" />
            </el-select>
          </template>
          <template #july_adjqty="{row}">
            <el-input v-model="row.july_adjqty" style="width: 60px" size="mini" @input="row.july_adjqty = row.july_adjqty.replace(/[^\d]/, '')" />
            <el-checkbox v-model="row.july_minus" size="mini" false-label="" true-label="X" />负数
          </template>
          <template #august_adjqty="{row}">
            <el-input v-model="row.august_adjqty" size="mini" style="width: 60px" @input="row.august_adjqty = row.august_adjqty.replace(/[^\d]/, '')" />
            <el-checkbox v-model="row.august_minus" size="mini" false-label="" true-label="X" />负数

          </template>
          <template #sep_adjqty="{row}">
            <el-input v-model="row.sep_adjqty" size="mini" style="width: 60px" @input="row.sep_adjqty = row.sep_adjqty.replace(/[^\d]/, '')" />
            <el-checkbox v-model="row.sep_minus" size="mini" false-label="" true-label="X" />负数

          </template>
          <template #oct_adjqty="{row}">
            <el-input v-model="row.oct_adjqty" size="mini" style="width: 60px" @input="row.oct_adjqty = row.oct_adjqty.replace(/[^\d]/, '')" />
            <el-checkbox v-model="row.oct_minus" size="mini" false-label="" true-label="X" />负数

          </template>
          <template #nov_adjqty="{row}">
            <el-input v-model="row.nov_adjqty" size="mini" style="width: 60px" @input="row.nov_adjqty = row.nov_adjqty.replace(/[^\d]/, '')" />
            <el-checkbox v-model="row.nov_minus" size="mini" false-label="" true-label="X" />负数
          </template>
        </vxe-grid>
      </TableCommon>

      <TableCommon v-if="!isSave" title="附件" :custome-config="() => vxeShowCustom('gridFile')">
        <vxe-grid
          ref="gridFile"
          class="table-block"
          border
          :highlight-hover-row="true"
          resizable
          :show-overflow="true"
          height="240"
          max-height="500"
          align="center"
          size="mini"
          :checkbox-config="{ highlight: true }"
          :radio-config="{ highlight: true }"
          :empty-render="{ name: 'NotData' }"
          :toolbar-config="{ custom: true, size: 'mini' }"
          :row-config="{ isCurrent: true }"
          :edit-config="{ trigger: 'manual', mode: 'row' }"
          :columns="gridFile.columns"
          :data="gridFile.data"
        >
          <template #fileName="{row}">
            <span class="blue" @click="dowLoadFile(row)">{{ row.fileName }}</span>
          </template>
          <template #createdDate="{row}">
            <span>{{ row.createdDate || row.creator.createdDate }}</span>
          </template>
        </vxe-grid>
      </TableCommon>
    </div>
  </div>

</template>

<script>
import { apiLoadDictionaryDtl } from '@/api/platform/dictionary/index'
import { generateUUID } from '@/api/flowHander'
import { apiContractPlanQuery, apiContractPlanSave } from '@/api/sap/contract'
import { printContractPlan, webUploadFile, apiAttachmentDownFile } from '@/api/common'
import { mapGetters } from 'vuex'
import { download } from '@/utils/frontExport'

export default {
  data() {
    return {
      errorList: [],
      file_uuid: '',
      salCenters: [],
      gridOptions: {
        columns: [
          { field: 'sal_center', title: '营销大区', width: 120, slots: { default: 'sal_center' }},
          { field: 'customer', title: '客户编码', width: 120 },
          { field: 'cust_name', title: '订单客户名称', width: 200 },
          { field: 'plan_type_name', title: '计划类型', width: 180 },
          { field: 'chfl_name', title: '存货分类', width: 120 },
          { field: 'july_qty', title: '7月计划量', width: 100 },
          { field: 'july_adjqty', title: '7月调整量', slots: { default: 'july_adjqty' }, width: 140 },
          { field: 'august_qty', title: '8月计划量', width: 100 },
          { field: 'august_adjqty', title: '8月调整量', slots: { default: 'august_adjqty' }, width: 140 },
          { field: 'sep_qty', title: '9月计划量', width: 100 },
          { field: 'sep_adjqty', title: '9月调整量', slots: { default: 'sep_adjqty' }, width: 140 },
          { field: 'oct_qty', title: '10月计划量', width: 100 },
          { field: 'oct_adjqty', title: '10月调整量', slots: { default: 'oct_adjqty' }, width: 140 },
          { field: 'nov_qty', title: '11月计划量', width: 100 },
          { field: 'nov_adjqty', title: '11月调整量', slots: { default: 'nov_adjqty' }, width: 140 }
        ],
        data: [{
          guid: '',
          sal_center: '',
          customer: '',
          cust_name: '',
          plan_type: '',
          chfl: '',
          july_qty: '',
          july_adjqty: '',
          august_qty: '',
          august_adjqty: '',
          sep_qty: '',
          sep_adjqty: '',
          oct_qty: '',
          oct_adjqty: '',
          nov_qty: '',
          nov_adjqty: '',
          july_minus: '',
          august_minus: '',
          sep_minus: '',
          oct_minus: '',
          nov_minus: ''
        }]
      },
      gridFile: {
        columns: [
          {
            field: 'fileName',
            title: '附件名称',
            slots: { default: 'fileName' }
          },
          {
            field: 'fileKind',
            title: '附件类型'
          },
          {
            field: 'fileSize',
            title: '大小'
          },
          {
            field: 'createdDate',
            title: '上传时间',
            slots: { default: 'createdDate' }
          }
        ],
        data: []
      }
    }
  },
  computed: {
    ...mapGetters(['role', 'customerInfo']),
    isSave() {
      return !this.gridOptions.data[0].guid
    }
  },
  created() {
    this.init()
  },
  methods: {
    init() {
      const { yxdy } = this.customerInfo
      if (yxdy.length) {
        this.gridOptions.data[0].sal_center = yxdy[0].zzfld00001h
        this.salCenters = yxdy
      }
      this.queryPlan()
      // 计划类型
      this.getSelectDictDataOrigin('A0002')
      // 获取生成文件id
      generateUUID().then(res => {
        this.file_uuid = res.data
      })
    },
    queryPlan() {
      this.errorList = []
      apiContractPlanQuery({ user_bp: this.customerInfo.info.partner, sal_center: this.gridOptions.data[0].sal_center }).then(res => {
        if (res.msgtype === 'E') {
          this.errorList = [res.message]
          return
        }
        this.formatData(res.data)
        this.gridOptions.data = res.data
      })
    },
    formatData(data) {
      const fileds = ['july_qty', 'july_adjqty', 'august_qty', 'august_adjqty', 'sep_qty', 'sep_adjqty', 'oct_qty', 'oct_adjqty', 'nov_qty', 'nov_adjqty']
      data.forEach(item => {
        fileds.forEach(key => {
          item[key] = Number(item[key])
        })
      })
    },
    async saveData(mode = 'SAVE') {
      const params = {
        mode,
        data: this.gridOptions.data,
        user_bp: this.customerInfo.info.partner
      }
      this.errorList = []
      const { data, msgtype, message } = await apiContractPlanSave(params)
      if (msgtype === 'E') {
        this.errorList = [message]
        return
      }
      this.$message.success(mode !== 'SAVE' ? '上传成功' : message)
      this.formatData(data)
      this.gridOptions.data = data
    },
    formatMinus(data) {
      return data.map(item => {
        return {
          ...item,
          july_adjqty: item.july_minus ? -1 * item.july_adjqty : item.july_adjqty,
          august_adjqty: item.august_minus ? -1 * item.august_adjqty : item.august_adjqty,
          sep_adjqty: item.sep_minus ? -1 * item.sep_adjqty : item.sep_adjqty,
          oct_adjqty: item.oct_minus ? -1 * item.oct_adjqty : item.oct_adjqty,
          nov_adjqty: item.nov_minus ? -1 * item.nov_adjqty : item.nov_adjqty
        }
      })
    },
    async downloadPdf() {
      const { data } = await printContractPlan(this.formatMinus(this.gridOptions.data))
      const a = document.createElement('a')
      const src = URL.createObjectURL(new Blob([data], { type: 'application/pdf' }))
      a.href = src
      a.download = '2023年合同计划量调整申请表'
      document.body.appendChild(a)
      a.click()
      window.URL.revokeObjectURL(a.href)
      document.body.removeChild(a)
    },
    async dowLoadFile({ file_id, id, fileName }) {
      const res = await apiAttachmentDownFile({ id: file_id || id })
      download(res.data, fileName)
    },
    async uploadFile(file) {
      const formData = new FormData()
      formData.append('bizId', this.file_uuid)
      formData.append('bizCode', 'planTransform')
      formData.append('formSecretLevel', 0)
      formData.append('name', file.name)
      formData.append('type', file.raw.type)
      formData.append('lastModifiedDate', file.raw.lastModifiedDate)
      formData.append('size', file.size)
      formData.append('file', file.raw)
      const { data } = await webUploadFile(formData)
      this.gridFile.data = [data]
      this.gridOptions.data.map(item => {
        item.file_id = data.id
      })
      this.saveData('SAVE_FILE_ID')
    },
    getSelectDictDataOrigin(dictcode) {
      const formData = new FormData()
      formData.append('code', dictcode)
      apiLoadDictionaryDtl(formData)
        .then(response => {
          this.$set(this['selectDataOptions'], dictcode, response.data.Rows)
        })
        .catch(() => {})
    }
  }
}
</script>

<style lang="scss" scoped>
.blue {
  color: rgb(45, 146, 214);
  cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// src/views/contract-manage/contractPlanNumChange.vue